import React from "react";

function Home() {
  return (
    <main class="flex-shrink-0">
      <div class="container">
      
        <p class="mt-4 fs-3">
          Let's pool together money to buy a brand new Lamborghini.
        </p>
        <div class="row my-4">
          <div class="col-xl-3">
              <div>
                <p>
                  Location
                </p>
                <div class="btn-group">
                  <button type="button" class="btn btn-secondary dropdown-toggle btn-lg" data-bs-toggle="dropdown" aria-expanded="false">
                    New York
                  </button>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="">New York</a></li>
                    <li><a class="dropdown-item" href="./london">London</a></li>
                    <li><a class="dropdown-item" href="./paris">Paris</a></li>
                  </ul>
                </div>
              </div>
              <div class="mt-3">
                <p>
                  Funding
                </p>
                <p class="fs-2">
                  21  / 90 ETH
                </p>
                <div class="bar">
                  <div class="progress"></div>
                </div>
                <a href="" class="btn btn-dark btn-lg my-4">Join DAO</a>
              </div>
          </div>
          <div class="col-xl-8 text-center mx-auto mb-5">
            <img class="img-fluid slide" src="./images/lambo.jpg"></img><br/>
            
          </div>
          

        </div>
      </div>
    </main>
  );
}

export default Home;